import _taggedTemplateLiteral from "/Users/diego.sampaio/olx/connecting/chat-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
import styled from 'styled-components';
import { Text } from '../Text';
import { withMargins } from '../../mixins';
const borderColor = _ref => {
  let {
    checked,
    hover,
    error,
    outline = false
  } = _ref;
  if (error) return 'var(--radio-border-color-error)';
  if (checked && hover) return 'var(--radio-background-color-checked-hover)';
  if (checked) return 'var(--radio-background-color-checked)';
  if (hover) return 'var(--radio-border-color-hover)';
  if (outline) return 'var(--radio-border-color-hover)';
  return 'var(--radio-border-color-hover)';
};
export const Label = styled(Text.BodyMedium)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), _ref2 => {
  let {
    outline,
    checked
  } = _ref2;
  return outline && checked ? "var(--color-secondary-100)" : "var(--radio-font-color)";
});
export const Radio = styled.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: fit-content;\n  display: ", ";\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  outline: none;\n\n  ", ";\n\n  ", ";\n\n  &:hover {\n    ", "\n  }\n\n  ", "\n"])), _ref3 => {
  let {
    display = 'inline'
  } = _ref3;
  return display === 'block' ? 'flex' : 'inline-flex';
}, _ref4 => {
  let {
    disabled
  } = _ref4;
  return disabled && "\n      opacity: var(--opacity-medium);\n      cursor: not-allowed;\n    ";
}, _ref5 => {
  let {
    outline,
    checked,
    error
  } = _ref5;
  return outline ? "\n      padding: var(--spacing-1) var(--spacing-2);\n      border-color: ".concat(borderColor({
    checked,
    hover: false,
    error,
    outline: true
  }), ";\n      border-width: var(--border-width-hairline);\n      border-radius: var(--border-radius-sm);\n      border-style: solid;\n\n      &:hover {\n        border-color: ").concat(borderColor({
    checked,
    hover: true,
    error,
    outline: true
  }), ";\n\n        ").concat(checked && "\n         ".concat(Label, " {\n          color: var(--color-secondary-120);\n        }"), "\n      }\n    ") : "\n      border-radius: var(--border-radius-pill);\n    ";
}, _ref6 => {
  let {
    checked
  } = _ref6;
  return checked && "\n      svg {\n        color: var(--color-secondary-120);\n      }\n    ";
}, withMargins);
export const RadioContentWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: fit-content;\n"])));
export const RadioContent = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
export const RadioNativeInput = styled.input(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 0;\n  width: 1px;\n  height: 1px;\n"])));
export const RadioInput = styled.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  min-width: 24px;\n  width: 24px;\n  max-width: 24px;\n  min-height: 24px;\n  height: 24px;\n  max-height: 24px;\n  border-radius: var(--border-radius-pill);\n  padding: var(--spacing-0-25);\n  :focus-within {\n    outline: var(--color-neutral-130) solid var(--border-width-thin);\n  }\n"])));
export const RadiotStylizedInput = styled.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  border-color: ", ";\n  border-width: ", ";\n  border-radius: var(--border-radius-pill);\n  border-style: solid;\n\n  ", ":hover:not([disabled]) & {\n    background-color: var(--radio-background-color-hover);\n    border-color: ", ";\n    border-width: var(--border-width-thin);\n  }\n\n  ", ":active:not([disabled]) & {\n    transform: scale(0.92);\n  }\n\n  ::after {\n    content: '';\n    width: 12px;\n    height: 12px;\n    background-color: ", ";\n    border-radius: var(--border-radius-pill);\n\n    ", ":hover:not([disabled]) & {\n      background-color: ", ";\n    }\n  }\n"])), _ref7 => {
  let {
    error
  } = _ref7;
  return error ? 'var(--radio-background-color-error)' : 'var(--radio-background-color-base)';
}, _ref8 => {
  let {
    checked,
    error
  } = _ref8;
  return borderColor({
    checked,
    hover: false,
    error
  });
}, _ref9 => {
  let {
    checked
  } = _ref9;
  return checked ? 'var(--border-width-thin)' : 'var(--border-width-hairline)';
}, Radio, _ref10 => {
  let {
    checked,
    error
  } = _ref10;
  return borderColor({
    checked,
    hover: true,
    error
  });
}, Radio, _ref11 => {
  let {
    checked
  } = _ref11;
  return checked ? 'var(--radio-background-color-checked)' : 'transparent';
}, Radio, _ref12 => {
  let {
    checked
  } = _ref12;
  return checked ? 'var(--radio-background-color-checked-hover)' : 'transparent';
});
export const LabelWrapper = styled.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin-left: var(--spacing-1);\n"])));
export const RadioCustomIcon = styled.span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin-left: var(--spacing-1);\n  display: flex;\n\n  ", "\n"])), _ref13 => {
  let {
    checked
  } = _ref13;
  return checked && "\n    svg {\n      color: var(--color-secondary-100)\n    }\n  ";
});
export const RadioErrorMessage = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  column-gap: 4px;\n  color: var(--color-feedback-error-100);\n  margin-top: var(--spacing-0-5);\n"])));